import { Injectable } from '@angular/core';
import { AgApiService } from '../../global/gx-ag-grid/ag-api.service';
import { CCLocation } from '../../../models/locations-models/cc-location';

@Injectable()
export class CcListApiService extends AgApiService<CCLocation>{
  constructor() {
    super();
  }
}